
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trial_lessons/a",
      function () {
        return require("private-next-pages/trial_lessons/a/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trial_lessons/a"])
      });
    }
  